import { DocumentTaskUpdate } from './../../../../components/task-assignment/model/document-task-update';
import { TaskAssignmentService } from './../../../../components/task-assignment/service/task-assignment.service';
import { TaskCompletion } from './../../../../components/task-assignment/model/task-completion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EntranceLeaveTask } from '../../register-entrance-leave.model';
import { MatDialog } from '@angular/material/dialog';
import { AppServerAPI, DialogService, DocumentDialogComponent } from '@sdbn/common';
import { PictureSeriesTaskDialogComponent } from './picture-series-task-dialog.component';
import { TaskProcessingHintDialogComponent } from './task-processing-hint.dialog.component';

@Component({
  selector: 'app-task-item',
  templateUrl: './task-item.component.html',
  styleUrls: ['./task-item.component.scss']
})
export class TaskItemComponent {

  @Input() task: EntranceLeaveTask;

  @Input() transportId: number;

  @Output() changed = new EventEmitter<null>();

  requestRunning: boolean = false;

  constructor(
    private dialogService: DialogService,
    private dialog: MatDialog,
    private taskAssignmentService: TaskAssignmentService,
    private http: AppServerAPI
  ) { }

  public completeTask() {

    this.requestRunning = true;
    // this.responseMessages = [];

    const completion = new TaskCompletion();
    completion.taskId = this.task.id;
    completion.transportId = this.transportId;
    completion.documentIds = this.task.documentIds;
    completion.resourceIds = this.task.resourceIds;

    this.taskAssignmentService.completeTask(completion).
      subscribe(result => {
        this.changed.next();
        this.requestRunning = false;
      }, error => {
        this.requestRunning = false;
      });

  }

  public completeDocument() {

    const dialogRef = this.dialog.open(DocumentDialogComponent, {
      height: '90%',
      width: '90%',
      maxHeight: '1600px',
      maxWidth: '1024px',
      data: {
        documentIds: this.task.documentIds, documentTemplateId: this.task.documentTemplateId, transportId: this.transportId,
        addDocumentsEnabled: true
      },
    });
    dialogRef.afterClosed().subscribe(storedDocuments => {
      if (storedDocuments != null) {

        this.task.documentIds = [];
        for (const doc of storedDocuments) {
          this.task.documentIds.push(doc.id);
        }

        if (!this.task.done) {
          this.completeTask();
        } else {
          this.updateDocumentTask();
        }
      }
    });

  }

  public updateDocumentTask() {

    this.requestRunning = true;

    const update = new DocumentTaskUpdate();
    update.taskId = this.task.id;
    update.transportId = this.transportId;
    update.documentIds = this.task.documentIds;

    this.taskAssignmentService.updateDocumentTask(update).
      subscribe(result => {
        this.changed.next();
        this.requestRunning = false;
      }, error => {
        this.requestRunning = false;
      });
  }


  handleResourceUpload(resourceId: string) {

    this.task.resourceIds.push(resourceId);
    this.completeTask();


  }

  completePictureSeries() {
    this.dialogService.openMaxHeight(PictureSeriesTaskDialogComponent, {}).afterClosed().subscribe(result => {
      if (result) {
        this.task.resourceIds = result;
        this.completeTask();
      }
    });
  }

  public showProcessingHint() {
    if (this.task.processingHint != null) {
      this.dialogService.openMaxHeight(TaskProcessingHintDialogComponent, this.task.processingHint);
    }
  }

}
